<template>
  <div>
    <el-steps :active="paso_actual" align-center>
      <el-step
        v-for="(item, index) in revisores_history"
        :key="index">
        <template slot="title">
          {{item.revisores.join(' - ')}}
        </template>
        <template slot="description">
          <div>{{item.personas.join(' - ')}}</div> 
          <br> 
          <!-- <div>{{`${index === (paso_actual - 1) ? `${ultimoRevisor}` : ``}`}}</div>  -->
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  props: ["revisores_history", "paso_actual", "fechaUltimaRevision", "ultimoRevisor"],
};
</script>